import gql from 'graphql-tag';

export default gql`
query listFA_DiscountDropdown($languageId: Int){
    fakturaAssist{
    listFA_DiscountDropdown(languageId: $languageId){
		id
		name
    }
    
  }
}`;
